// Screen tests use this to prove a page carries every element its walkthrough points at
// (18-help-and-training.md §18.3). A walkthrough step names its element by `data-tour`.

/** The CSS selector for a walkthrough target. */
export const tourSelector = (target: string): string => `[data-tour="${target}"]`;

/** The targets of these steps that are not on the page. Empty when every one is there. */
export function missingTourTargets(
  root: ParentNode,
  steps: readonly { target?: string | undefined }[],
): string[] {
  const missing: string[] = [];
  for (const s of steps) {
    if (s.target && !root.querySelector(tourSelector(s.target))) missing.push(s.target);
  }
  return [...new Set(missing)];
}
